export const overrideRedirectUri = (uri: string, replacement: string): string => {
  try {
    const url = new URL(uri);
    const params = new URLSearchParams(url.search);
    params.set('redirect_uri', replacement);
    url.search = params.toString();
    return url.toString();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to update redirect URI:', e);
    return uri;
  }
};
